import { render, staticRenderFns } from "./Jurnalentri.vue?vue&type=template&id=45771db0"
import script from "./Jurnalentri.vue?vue&type=script&lang=js"
export * from "./Jurnalentri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports